import { render, staticRenderFns } from "./KeywordPlannerValueColumn.vue?vue&type=template&id=608f8358"
import script from "./KeywordPlannerValueColumn.vue?vue&type=script&lang=js"
export * from "./KeywordPlannerValueColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports